<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddEducationHistory"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Education History</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <h1 class="font-extrabold ml-1">Education Details</h1>
          <div class="p-4 grid grid-cols-2 gap-4">
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Institution Name</label>
                <input
                  v-model="info.InstitutionName"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Course Name</label>
                <input
                  v-model="info.CourseName"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Start Date</label>
                <input
                  v-model="info.StartDate"
                  required
                  type="date"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">End Date</label>
                <input
                  v-model="info.EndDate"
                  required
                  type="date"
                  :min="new Date(info.StartDate).toISOString().split('T')[0]"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Awarded</label>
                <input
                  v-model="info.Awarded"
                  placeholder="e.g Degree"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-md px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
export default {
  name: "AddEmploymentHistory",
  props: [
    "showAddEducationHistory",
    "setShowAddEducationHistory",
    "personalInfo",
    "homeAndContactInfo",
    "emergencyContactInfo",
    "sectionData",
    "empData",
    "reload",
    "close",
  ],
  components: { Loader },
  data() {
    return {
      loading: false,
      show: [false, false],
      display: false,

      showStatus: false,
      create_error: null,
      create_success: null,

      saved_salutation: ["Mrs", "Ms", "Mr", "Sir"],
      info: {
        InstitutionName: "",
        CourseName: "",
        StartDate: new Date(),
        EndDate: "",
        Awarded: "",
      },
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken", "getTabTitle"]),
  },
  created() {},
  methods: {
    updateField(e, field) {
      //console.log(this.empData)
      const { value } = e.target;
      //console.log(field, value)
      this.data = { ...this.data, [field]: value };
      //console.log(this.data)
    },
    setGender(option) {
      this.genderSelected = option;
      this.showGender = false; // hide the dropdown after an option is selected
    },

    // /{organization}/employee/education/history/v1/create
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          `${this.getOrganization}/employee/education/history/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.reload();
              this.create_success = response.data.StatusMessage;
              this.info = {
                InstitutionName: "",
                CourseName: "",
                StartDate: new Date(),
                EndDate: "",
                Awarded: "",
              };
              setTimeout(() => {
                this.$emit("closeOnSuccess", response.data.StatusMessage);
                this.create_success = null;
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
